// import { useContext } from 'react'

// import { gnarSpec } from '@lib/tracking/gnar'
// import { PageContext } from '@contexts/page-context'
// import { PlacementContext } from '@contexts/placement-context'
import type { Inline } from '@contentful/rich-text-types'
import type { ReactElement, ReactNode } from 'react'

import { Link } from '@components/ui-core/link/link'

interface InlineLinkProps extends Inline {
  children?: ReactNode
}

export function InlineLink({ children, data }: InlineLinkProps): ReactElement {
  const href = data.uri || ''

  // @TODO: Update tracking for inline links
  // const { pageId, slug } = useContext(PageContext)
  // const { placement, placementInternalName } = useContext(PlacementContext)
  const isAnchorLink = href.startsWith('#')

  return (
    <Link
      onClick={() => {
        // void gnarSpec.linkClick(pageId, slug, href, undefined, placement, placementInternalName)
      }}
      href={href}
      target={isAnchorLink ? undefined : '_blank'}
    >
      {children}
    </Link>
  )
}
